import { useState, useEffect } from "react";
import Button from "../../HomePage/Button";
import { useStudioEditor } from "../../../store/studioEditorStore";

import ErrorMessage from "../../StudioErstellen/ErrorMessage";
import classes from "../../StudioErstellen/Amenities.module.css";

export const AmenitiesEditor = ({ studio, validate }) => {
    const availableAmenities = [
        "WLAN", "Küche", "Heizung", "Klimaanlage", "Kostenloser Parkplatz", "Umkleiden", 
        "Badezimmer/WC", "Schalldämmung", "Outdoor Bereich",
        "Rollstuhl-Zugang"
    ];

    const { updatedFields, updateField } = useStudioEditor();
    const [selectedAmenities, setSelectedAmenities] = useState([]);
    const [errors, setErrors] = useState({
        name: ""
    });

    // Initialize with studio data when component mounts or when studio changes
    useEffect(() => {
        if (studio) {
            // Use updated amenities if available, otherwise use amenities from studio
            const currentAmenities = updatedFields.amenities ?? studio.amenities ?? [];
            
            setSelectedAmenities(currentAmenities);
        }
        // Only hydrate local state on studio changes. User toggles update local state directly.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [studio]);

    const toggleAmenity = (amenity) => {
        const newSelectedAmenities = selectedAmenities.includes(amenity)
            ? selectedAmenities.filter(t => t !== amenity)
            : [...selectedAmenities, amenity];
            
        setSelectedAmenities(newSelectedAmenities);
        updateField('amenities', newSelectedAmenities);
    };

    const handleValidation = () => {
        let isValid = true;
        const newErrors = {
            name: ""
        };

        if (selectedAmenities.length === 0) {
            newErrors.name = "Bitte wähle mindestens eine Grundausstattung aus.";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    useEffect(() => {
        if (validate && validate.current) {
            validate.current = handleValidation;
        }
    }, [validate, selectedAmenities]);

    return (
        <div className={classes.mainContainer}>
            <div className={classes.titleContainer}>
                <h2 style={{marginBottom: '30px'}} className={`${classes.title} titleSemibold`}>Grundausstattung</h2>
            </div>
            <div className={classes.bottomContainer}>
                {availableAmenities.map((amenity) => 
                    <div key={amenity} className={classes.suggestionsContainer}>
                        <Button
                            onClick={() => toggleAmenity(amenity)}
                            text={amenity}
                            activebutton={selectedAmenities.includes(amenity)}
                        />
                    </div>
                )}
            </div>
            {errors.name && <ErrorMessage>{errors.name}</ErrorMessage>}
        </div>
    );
};

export default AmenitiesEditor;
